class FavoritesManager {
  constructor() {
    this.favorites = this.loadFavorites();
    this.init();
  }

  loadFavorites() {
    const stored = localStorage.getItem('shopify_favorites');
    return stored ? JSON.parse(stored) : [];
  }

  saveFavorites() {
    localStorage.setItem('shopify_favorites', JSON.stringify(this.favorites));
  }

  toggleFavorite(productId, productHandle) {
    const index = this.favorites.findIndex(fav => fav.id === productId);
    
    if (index > -1) {
      this.favorites.splice(index, 1);
    } else {
      this.favorites.push({
        id: productId,
        handle: productHandle,
        addedAt: new Date().toISOString()
      });
    }
    
    this.saveFavorites();
    this.updateUI();
  }

  isFavorite(productId) {
    return this.favorites.some(fav => fav.id === productId);
  }

  updateUI() {
    const buttons = document.querySelectorAll('[data-favorites-toggle]');
    
    buttons.forEach(button => {
      const wrapper = button.closest('[data-product-id]');
      if (wrapper) {
        const productId = parseInt(wrapper.dataset.productId);
        const isFavorite = this.isFavorite(productId);
        button.classList.toggle('is-favorite', isFavorite);
      }
    });
  }

  init() {
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-favorites-toggle]')) {
        e.preventDefault();
        e.stopPropagation();
        
        const button = e.target.closest('[data-favorites-toggle]');
        const wrapper = button.closest('[data-product-id]');
        const productId = parseInt(wrapper.dataset.productId);
        const productHandle = wrapper.dataset.productHandle;
        
        this.toggleFavorite(productId, productHandle);
      }
    });

    // Listen for favorites updates from other components
    document.addEventListener('favorites:updated', (e) => {
      const { productId, action } = e.detail;
      if (action === 'removed') {
        this.favorites = this.favorites.filter(fav => fav.id !== productId);
        this.updateUI();
      } else if (action === 'added') {
        this.favorites = this.loadFavorites();
        this.updateUI();
      }
    });

    // Update UI on page load
    this.updateUI();
  }
}

// Initialize favorites manager when DOM is ready
if (!window.favoritesManager) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.favoritesManager = new FavoritesManager();
    });
  } else {
    window.favoritesManager = new FavoritesManager();
  }
}
